/**
 * Jul-2026 (User-Wunsch) — Vergessene PFLICHTFELDER sichtbar machen:
 * direkt zum Feld springen, fokussieren und animieren (Puls + roter Rahmen).
 */
export function flashMissingField(el) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch { /* noop */ }
    el.classList.remove("tw-missing-field");
    void el.offsetWidth; // Animation neu starten
    el.classList.add("tw-missing-field");
    try { el.focus({ preventScroll: true }); } catch { /* noop */ }
    setTimeout(() => el.classList.remove("tw-missing-field"), 3500);
}

export function flashMissingByTestId(testId) {
    flashMissingField(document.querySelector(`[data-testid="${testId}"]`));
}
